import cx from 'classnames';
import { Editor } from 'codemirror';
import { RefreshKids } from 'education-icons';
import React, { useRef, useState } from 'react';

import { Button } from '../../button/button';
import { RobotCodeLoadable } from '../../robot/__code/robot__code-loadable';

// @ts-ignore
import styles from './coding-problem__stdio.module.scss';

interface Props {
    value?: string;
    resetToValue?: string;
    title?: React.ReactNode;
    titleRef?: React.RefObject<HTMLSpanElement>;
    className?: string;
    onChange?: (value: string) => void;
    readOnly?: boolean;
    attention?: boolean;
    isException?: boolean;
}

export const Stdio = (props: Props) => {
    const [dirty, setDirty] = useState(false);
    const editorRef = useRef<Editor>();
    const reset = () => editorRef.current?.setValue(props.resetToValue || '');

    return (
        <div className={cx(styles.stdio, props.className)}>
            {props.title && (
                <span className={styles.stdio__title} ref={props.titleRef}>
                    {props.title}
                </span>
            )}
            <div className={styles.stdio__editor}>
                <RobotCodeLoadable
                    className={cx(styles.stdio__code, {
                        [styles.stdio__code_dirty]: dirty,
                        [styles.stdio__code_attention]: props.attention,
                        [styles.stdio__code_attention_exception]: props.isException,
                        [styles.stdio__code_readonly]: props.readOnly,
                    })}
                    editorRef={editorRef}
                    onChange={(_editor, _data, value) => {
                        props.onChange?.(value);
                        setDirty(value !== props.resetToValue);
                    }}
                    options={{
                        mode: 'text',
                        indentUnit: 4,
                        readOnly: Boolean(props.readOnly),
                        cursorScrollMargin: 0,
                        styleActiveLine: false,
                    }}
                    paddingBottom={0}
                    paddingRight={0}
                    value={props.value || ''}
                />
                {!props.readOnly && (
                    <Button
                        className={styles.stdio__reset}
                        disabled={!dirty}
                        icon={<RefreshKids />}
                        onClick={reset}
                        rounded
                        size={Button.SIZE.S}
                        view={Button.VIEW.ACTION}
                    />
                )}
            </div>
        </div>
    );
};
